import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
  wrapperContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '1440px',
    padding: '0 16px',
  },

  actionsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(1, 1fr)',
    rowGap: '56px',
    columnGap: '76px',
    width: '100%',
    marginBottom: '32px',
    marginTop: '32px',
    [theme.breakpoints.up('tablet_s')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    [theme.breakpoints.up('laptop')]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
    [theme.breakpoints.up('laptop_l')]: {
      gridTemplateColumns: 'repeat(4, 1fr)',
    },
  },

  actionCardContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    padding: '15px',
    borderRadius: '15px',
    border: `2px solid ${theme.palette.custom.grey}`,
    transition: 'background-color 0.2s ease-in-out',
    '&&:hover': {
      backgroundColor: theme.palette.custom.grey,
    },
  },
}))
